document.addEventListener("DOMContentLoaded", function(event) {
  $(function($) {
    var outofstock = document.querySelector('input[name="outofstock"]') ? 'yes' : undefined;
    var moneyFormat = theme.moneyFormat;

    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    function get_all_prds_prc() {
      var get_final_subtotal = 0;
      $('.current-prd-list-wrap .single-hidden-prc').each(function(a, b) {
        var a = parseInt($(this).html()) ? parseInt($(this).html()) : 0;
        get_final_subtotal += a;
      });

      $('.total-price .total-money, [data-regular-price]').html(formatMoney(get_final_subtotal, moneyFormat));
    }

    function addon_edit_html() {
      var qty = $('.product-form__item input[name="quantity"]').val();
      var get_year_val = '';

      if ($('.multi-var-sel').length) {
        get_year_val = $('.multi-var-sel').val();
      }

      var checked = [];
      var final_addon_html = '';

      if ($('.multi-var-check:checked').length) {
        $('.error-message').slideUp(800);
        $('.current-prd-list-wrap').slideDown(800);
        $('.multi-var-check:checked').each(function() {
          var get_var_txt = '';

          if (get_var_txt != '') {
            get_var_txt = get_year_val + ' / ' + $(this).val();
          } else {
            get_var_txt = $(this).val();
          }

          get_var_txt = get_var_txt.trim();
          checked.push(get_var_txt);
        });

        let qty_price = 0

        $(".custom-variant-wrap option").each(function(a, b) {
          //cmp_checked.push($(this).text().trim());

          var get_text_val = $(this).text().trim();
          var get_cur_val = $(this).val();

          var get_addons_nm = $(this).data('prdnm');
          var get_addons_prc = parseInt($(this).data('price'));
          var get_qty_for_main_prd = parseInt($('.product-form__item input[name="quantity"]').val());

          var get_main_prd_prc_qty = get_qty_for_main_prd * get_addons_prc;
          var get_cur_addon_num = $(this).data('getaddonnum');

          for (var j = 0; j < checked.length; j++) {

            if (checked[j] === get_text_val) {
              if (qty > 0) {
                final_addon_html += '<div class="addon-sin-prd-wrap addon-sin' + j + '">';
                final_addon_html += '<div class="addon-prd-title-qty-wrap">';
                final_addon_html += '<span class="main-prd-qty-wrap">' + qty + '</span>';
                final_addon_html += '</span><span class="main-prd-multi-wrap">x</span>';
                final_addon_html += '<div class="addon-prd-title-wrap">' + get_addons_nm + '</div>';
                final_addon_html += '</div>';
                final_addon_html += '<div class="addon-prd-prc-wrap">' + formatMoney(get_main_prd_prc_qty, moneyFormat) + '</div>';
                final_addon_html += '<div class="single-hidden-prc hide">' + get_main_prd_prc_qty + '</div>';
                final_addon_html += '</div>';

                $('.addon-prd-data-prc-wrap').html(final_addon_html);

                qty_price = qty_price + get_addons_prc
              }
            }
          }
        });

        document.querySelector('[data-total-price]').setAttribute('data-price-value', qty_price)
        document.querySelector('[data-regular-price]').setAttribute('data-regular-price', formatMoney(qty_price, moneyFormat))
        get_all_prds_prc();
      } else {
        $('.error-message').slideDown(800);
        $('.current-prd-list-wrap').slideUp(800);
        $('.addon-prd-data-prc-wrap').html('');
      }

      if (checked.length > 0) {
        $('.plus.button, .minus.button').removeClass('disabled')
      } else {
        $('.plus.button, .minus.button').addClass('disabled')

        $('[data-quantity-input]').val(1)
        $('[data-total-price], [data-regular-price]').html('$0.00')
      }
    }

    function setErrorMessage(msg) {
      $('.error-message').html(msg)
    }

    function initCollapsible() {
      const collapsibleEl = document.querySelector('[data-accordion-content]')

      if (!collapsibleEl) return

      collapsibleEl.style.setProperty('--collapsible-content-height', collapsibleEl.offsetHeight + 'px')

      const collapsibleToggleEl = document.querySelector('[data-accordion-toggle]')  

      if (!collapsibleToggleEl) return

      const parentEl = document.querySelector('[data-accordion]')

      collapsibleToggleEl.addEventListener('click', () => {
        parentEl.classList.toggle('collapsed')
      })
    }

    $('body').on('change', '.multi-var-sel', function() {
      var get_year_val = $(this).val();

      $('.multi-var-check').each(function() {
        $(this).prop("checked", false);
      });

    });

    $('body').on('change', '.multi-var-check', function() {

      if (outofstock === 'yes') {
        $('.custom-add-to-cart').html('Reserve Now');
      }
      addon_edit_html();
    });

    $('body').on('click', '.plus.button, .minus.button', function() {
      if (outofstock === 'yes') {
        $('.custom-add-to-cart').html('Reserve Now');
      }
      addon_edit_html();
    });

    $('body').on('click', '.custom-add-to-cart', function(evt) {

      evt.preventDefault();

      var toadd = [];
      var toItem = [];
      // create array for add to cart items
      var qty = $('.product-form__item input[name="quantity"]').val();

      var get_cur_ele = $(this);
      var outofstock = $(this).data('outofstock');
      var set_property = {};
      var get_year_val = '';

      if ($('.multi-var-sel').length) {
        get_year_val = $('.multi-var-sel').val();
      }

      var checked = [];

      var final_addon_html = '';

      var property_note = '';
      var propery_note_val = '';
      if (outofstock === "yes") {
        property_note = 'Note';
        propery_note_val = 'You have purchased an item that we currently do not have in stock. Once the product is in stock, we will notify you with shipping and delivery details.';
        set_property[property_note] = propery_note_val;
      }

      if ($('.multi-var-check:checked').length) {
        $('.error-message').slideUp(800);
        $('.current-prd-list-wrap').slideDown(800);
        $('.multi-var-check:checked').each(function() {
          var get_var_txt = '';

          if (get_year_val != '') {
            get_var_txt = get_year_val + ' / ' + $(this).val();
          } else {
            get_var_txt = $(this).val();
          }
          get_var_txt = get_var_txt.trim();
          checked.push(get_var_txt);
        });

        $(".custom-variant-wrap option").each(function(a, b) {
          //cmp_checked.push($(this).text().trim());
          var get_text_val = $(this).text().trim();
          var get_cur_val = $(this).val();

          var get_addons_nm = $(this).data('prdnm');
          var get_addons_prc = parseInt($(this).data('price'));
          var get_qty_for_main_prd = parseInt($('.product-form__item input[name="quantity"]').val());

          var get_main_prd_prc_qty = get_qty_for_main_prd * get_addons_prc;
          var get_cur_addon_num = $(this).data('getaddonnum');

          for (var j = 0; j < checked.length; j++) {
            if (checked[j] === get_text_val) {
              if (qty > 0) {
                toadd.push({
                  variant_id: parseInt(get_cur_val),
                  quantity_id: qty || 0,
                  properties: set_property

                });
                toItem.push({
                  variant_id: parseInt(get_cur_val),
                  quantity_id: qty || 0,
                  properties: set_property
                });

                final_addon_html += '<div class="addon-sin-prd-wrap addon-sin' + j + '">';
                final_addon_html += '<div class="addon-prd-title-qty-wrap">';
                final_addon_html += '<span class="main-prd-qty-wrap">' + qty + '</span>';
                final_addon_html += '</span><span class="main-prd-multi-wrap">x</span>';
                final_addon_html += '<div class="addon-prd-title-wrap">' + get_addons_nm + '</div>';
                final_addon_html += '</div>';
                final_addon_html += '<div class="addon-prd-prc-wrap">' + formatMoney(get_main_prd_prc_qty, moneyFormat) + '</div>';
                final_addon_html += '<div class="single-hidden-prc hide">' + get_main_prd_prc_qty + '</div>';
                final_addon_html += '</div>';

                $('.addon-prd-data-prc-wrap').html(final_addon_html);
              }
            }
          }
        });

        get_all_prds_prc();


        toadd = toadd.reverse();
        toItem = toItem.reverse();

        var itemCnt = 0;

        function moveAlong() {
          if (toadd.length) {
            var request = toadd.shift();
            var tempId = request.variant_id;
            var tempQty = request.quantity_id;
            var params = {
              type: 'POST',
              url: '/cart/add.js',
              data: 'quantity=' + tempQty + '&id=' + tempId,
              dataType: 'json',
              success: function(line_item) {
                itemCnt = itemCnt + 1;
                moveAlong();
                var checkLength = toItem.length;
                if (checkLength == itemCnt) {

                  var cartdata = [];
                  $.ajax({
                    type: 'GET',
                    url: '/cart.js',
                    async: false,
                    cache: false,
                    dataType: 'json',
                    success: function(json) {
                      cartdata = json;
                    }
                  });

                  $('.countPill.cart-quantity').text(cartdata.item_count);
                  $('[data-cart-preview-pc]').trigger("click");

                }
              },
              error: function(a, b) {
                moveAlong();

              }
            };

            $.ajax(params);
          }
        }
        moveAlong();
        setErrorMessage("");
      } else {
        setErrorMessage("Please select at least one of the options.");
        $('.error-message').slideDown(800);
        $('.current-prd-list-wrap').slideUp(800);
        $('.addon-prd-data-prc-wrap').html('');
      }
    });

    initCollapsible()
  });
})